define("SDB.SDBLocations.Model", [
  "SCModel",
  "Utils",
  "Singleton",
  "underscore",
], function (SCModelComponent, Utils, Singleton, _) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  function SDBLocationsModel(options) {
    SCModel.call(this);

    this.options = options;
    this.socialMediaLinks = SC.CONFIGURATION.SDBLocations.SocialMedia;

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
          "Modules/SDBLocations/SuiteScript2/SuiteDB.SDBLocations.Service.ss"
        ),
        true
      );
    };

    this.getCookie = function getCookie(keys) {
      var cookieOptions = document.cookie.split(";");
      var arrCookies = _.filter(cookieOptions, function (cookie) {
        return cookie.indexOf(keys + "=") !== -1;
      });
      return arrCookies;
    };

    /* Validate if the location is selected */
    this.isLocationSelected = function () {
      return !!this.get("location") || !!this.getCookie("location").length; //sessionStorage.getItem('location');
    };

    this.getSelectedLocation = function () {
      var locationCookie = this.getCookie("location")[0];
      return locationCookie
        ? JSON.parse(
            locationCookie.substring(locationCookie.indexOf("=") + 1).trim()
          )
        : this.get("location");
    };

    this.removeLocation = function removeLocation() {
      this.unset("location");
      this.removeCookie("location");
    };

    this.removeCookie = function removeCookie(keys) {
      _.each(this.getCookie(keys), function (cookie) {
        cookie = cookie.split("=")[0].trim();
        document.cookie =
          cookie + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
      });
    };

    this.setCookie = function setCookie(data) {
      this.removeCookie(Object.keys(data));

      for (var name in data) {
        if (Object.hasOwnProperty.call(data, name)) {
          var value = data[name];

          if (value instanceof Object || value instanceof Array) {
            value = JSON.stringify(value);
          }

          var expireDate = new Date();
          var daysAvailable = 30;
          expireDate.setTime(
            expireDate.getTime() + daysAvailable * 24 * 60 * 60 * 1000
          );
          var expires = "expires=" + expireDate.toUTCString();
          document.cookie = name + "=" + value + ";" + expires + "; path=/";
        }
      }

      this.set(data, { wait: true });
    };

    /* Get the locations */
    this.getLocations = function getLocations() {
      var locations = [];
      var onlineLocation;

      /* Get the locations from the cookie storage */
      var cookieLocations = this.getCookie("locations")[0];
      if (cookieLocations) {
        return JSON.parse(cookieLocations.split("=")[1].trim());
      } else if (this.get("locations")) {
        return this.get("locations");
      }

      /* If there are no locations in the cookies, get the locations from the backend */
      this.fetch({ async: false })
        .done(function (res) {
          locations = res;
        })
        .catch(function (err) {
          console.log(err);
        });

      /* Map the locations and set the name with a correct format */
      var arrMappedLocations = _.map(locations, function (location) {
        /* Get the separated fields */
        var separatedFields = _.clone(location.separatedFields) || {};
        delete location.separatedFields;

        var name = location.name ? location.name : ":";
        location.name = _.last(name.split(":")).trim();

        /* Merge the separated fields with the location and return it */
        return _.extend(location, { addrFields: separatedFields });
      });

      onlineLocation = _.findWhere(arrMappedLocations, { internalid: "6" });
      arrMappedLocations = _.reject(arrMappedLocations, function (value) {
        return value.internalid === "6";
      });

      // this.setCookie({ 'locations': arrMappedLocations }); // Set the locations on the cookie storage
      this.set(
        { locations: arrMappedLocations, onlineLocation: onlineLocation },
        { wait: true }
      );
      return arrMappedLocations; // Return the locations
    };

    this.getShoppingExperience = function () {
      var shoppingExperience = this.getCookie("shoppingExperience")[0];
      return shoppingExperience ? shoppingExperience.split("=")[1].trim() : "";
    };

    this.setLocationSocialMedia = function (location) {
      location.facebook = _.find(this.socialMediaLinks, function (socialMedia) {
        return (
          socialMedia.name.toLowerCase() === "facebook" &&
          location.internalid === socialMedia.id
        );
      });
      if (location.facebook && !location.facebook.image)
        location.facebook.image = "/site/Home Assets/icon_facebook.png";
      location.instagram = _.find(
        this.socialMediaLinks,
        function (socialMedia) {
          return (
            socialMedia.name.toLowerCase() === "instagram" &&
            location.internalid === socialMedia.id
          );
        }
      );
      if (location.instagram && !location.instagram.image)
        location.instagram.image = "/site/Home Assets/icon_instagram.png";
      location.linkedin = _.find(this.socialMediaLinks, function (socialMedia) {
        return (
          socialMedia.name.toLowerCase() === "linkedin" &&
          location.internalid === socialMedia.id
        );
      });
      if (location.linkedin && !location.linkedin.image)
        location.linkedin.image = "/site/Home Assets/icon_linkedin.png";
    };

    this.getFieldMapper = function (env) {
      var locationSortingIds = env.getConfig(
        "SDBPProductModifications.LocationsFilters"
      );
      if (!locationSortingIds) return {};
      var locationsList = this.get("locations");
      var onlineLocation = this.get("onlineLocation");
      var locationsAvailable = {};
      locationsAvailable[onlineLocation.name.toUpperCase()] = onlineLocation;
      var locationsAvailable = _.reduce(
        locationsList,
        function (acc, value) {
          acc[value.name.toUpperCase()] = value;
          return acc;
        },
        locationsAvailable
      );
      locationSortingIds = _.filter(locationSortingIds, function (location) {
        return !!locationsAvailable[location.location.toUpperCase()];
      });
      var objToReturn = {};
      locationSortingIds.forEach(function (location) {
        objToReturn[location.location.toUpperCase()] = {
          internal: location.fieldidint,
        };
      });
      return objToReturn;
    };

    this.getLocations();
  }

  SDBLocationsModel.prototype = Object.create(SCModel.prototype);
  SDBLocationsModel.prototype.constructor = SDBLocationsModel;

  return _.extend(SDBLocationsModel, Singleton); // Return the model as a singleton
});
